import { Text, SvgIcon } from '@cinch-labs/design-system'
import styles from './booking-page.module.css'
import { FindAStore } from '../../components/find-a-store/find-a-store'
import { FindYourCar } from '../../components/find-your-car/find-your-car'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { ConsumerValuationsProvider } from '@cinch-labs/data-consumer-valuations'
import { Env, readFromEnv } from '@cinch-nx/environments'
import {
  MaintenanceProvider,
  useMaintenanceContext,
} from '../../context/maintenance-context'
import { ChooseYourMaintenance } from '../../components/choose-your-maintenance'
import { SelectDateTime } from '../../components/select-date-time/select-date-time'
import { BookingNotes } from '../../components/booking-notes/booking-notes'
import { Summary } from '../../components/summary/summary'
import { ContactDetails } from '../../components/contact-details/contact-details'
import { BookingConfirmation } from '../../components/booking-confirmation/booking-confirmation'
import { ServiceOptionsExplainedDrawerProvider } from '../../components/choose-your-maintenance/service-options-explained'
import { MarshallExplanationDrawerProvider } from '../../components/find-a-store/marshall-explanation-drawer'
import { saveCampaignIdCookie } from '../../utils/campaign-id'

export const BookingPageContent: React.FC = () => {
  saveCampaignIdCookie()
  const IS_MOBILE_APP =
    typeof window !== 'undefined' &&
    window.navigator?.userAgent.includes('cinchapp')

  const router = useRouter()

  const { step, handleBack } = useMaintenanceContext()

  let currentStep: React.ReactNode = null
  switch (step) {
    case 1: {
      currentStep = <FindAStore />
      break
    }
    case 2: {
      currentStep = <FindYourCar />
      break
    }
    case 3: {
      currentStep = <ChooseYourMaintenance />
      break
    }
    case 4: {
      currentStep = <SelectDateTime />
      break
    }
    case 5: {
      currentStep = <BookingNotes />
      break
    }
    case 6: {
      currentStep = <ContactDetails />
      break
    }
  }

  return step === 7 || step === 8 ? (
    <div className={styles.container}>
      {step === 7 ? <Summary /> : <BookingConfirmation />}
    </div>
  ) : (
    <div>
      {!IS_MOBILE_APP && (
        <div className={styles.header} data-testid="header">
          <div className={styles.backButtonContainer}>
            <button
              className={styles.backButton}
              onClick={() => {
                if (step === 1) {
                  router.push('/servicing')
                } else {
                  handleBack()
                }
              }}
              aria-label="Back"
              title="Back"
            >
              <span className={styles.iconCircle}>
                <SvgIcon name="chevron-left" size={10} />
              </span>
              <Text
                element="span"
                fontSizeFixed="s"
                className={styles.backButtonText}
                aria-hidden="true"
              >
                Back
              </Text>
            </button>
          </div>

          <Text className={styles.title} element="h1" fontSize="xs">
            Book a service or MOT{' '}
          </Text>

          <div className={styles.rightSpacer}></div>
        </div>
      )}

      <div
        className={`${styles.container} ${
          IS_MOBILE_APP ? styles.mobileAppContainer : ''
        }`}
      >
        <Text
          element="p"
          fontSizeFixed="s"
          className={styles.stepText}
          aria-label={`Step ${step} of 6`}
        >
          Step {step} of 6
        </Text>
        {currentStep}
      </div>
    </div>
  )
}

export const BookingPage: React.FC = () => (
  <>
    <Head>
      <title>
        Book a car service or MOT from cinch | Faff-free car servicing - cinch
      </title>
      <link
        rel="icon"
        href="/favicon-32x32-bfc05e34c2d7531ace62bdb1cc158dfe.png"
      />
    </Head>
    <MaintenanceProvider>
      <ServiceOptionsExplainedDrawerProvider>
        <MarshallExplanationDrawerProvider>
          <ConsumerValuationsProvider
            consumerValuationsBaseUrl={readFromEnv(
              Env.consumerValuationsServiceUrl,
            )}
          >
            <BookingPageContent />
          </ConsumerValuationsProvider>
        </MarshallExplanationDrawerProvider>
      </ServiceOptionsExplainedDrawerProvider>
    </MaintenanceProvider>
  </>
)
